export const NOTIFICATION_TABLE_CLASSNAMES = {
  row: "relative w-full gap-2",
  unreadBadge: "w-4 shrink-0",
  // TODO: This is a temporary fix to make description not overflow
  description: "max-w-[217px] lg:max-w-[286px] w-auto grow",
  side: "w-[140px] justify-end last:pr-6",
}
